// extracted by mini-css-extract-plugin
module.exports = {"ui-table":"styles__ui-table___2K0bs"};